import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../lib/supabase';
import { Button } from './ui/button';
import { Loader2, UserX, RotateCcw } from 'lucide-react';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export const AccountDisabledGate = ({ children }) => {
  const { profile } = useAuth();
  const [busy, setBusy] = useState(false);

  // Mostra la schermata solo se il profilo dell'utente loggato è disattivato
  if (!profile || !profile.deleted_at) return children;

  const authHeader = async () => {
    const { data } = await supabase.auth.getSession();
    const t = data?.session?.access_token;
    return t ? { Authorization: `Bearer ${t}` } : null;
  };

  const restore = async () => {
    setBusy(true);
    const h = await authHeader();
    try {
      const res = await fetch(`${API}/api/account/restore`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', ...h },
      });
      if (!res.ok) throw new Error('Ripristino non riuscito');
      toast.success('Account ripristinato');
      window.location.href = '/';
    } catch (e) {
      toast.error(e.message);
      setBusy(false);
    }
  };

  const logout = async () => {
    await supabase.auth.signOut();
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4" data-testid="account-disabled-gate">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 border border-slate-100 text-center">
        <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4">
          <UserX className="w-7 h-7 text-amber-600" />
        </div>
        <h1 className="text-2xl font-bold text-slate-800">Account disattivato</h1>
        <p className="text-slate-500 text-sm mt-3 mb-6">
          Il tuo account è attualmente disattivato. Puoi ripristinarlo subito per riavere accesso al profilo,
          alla vetrina e ai prodotti, oppure uscire.
        </p>
        <Button onClick={restore} disabled={busy} className="w-full bg-[#008080] hover:bg-[#006666] h-11 mb-3" data-testid="account-restore-button">
          {busy ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <RotateCcw className="w-4 h-4 mr-2" />}
          Ripristina il mio account
        </Button>
        <button onClick={logout} className="text-sm text-slate-500 hover:text-slate-700" data-testid="account-logout-button">
          Esci
        </button>
      </div>
    </div>
  );
};

export default AccountDisabledGate;
